/* global axios */

const base = accountId =>
  `/api/v1/accounts/${accountId}/kanban/connections`;

export default {
  getProviders(accountId) {
    return axios.get(`${base(accountId)}/providers`);
  },

  getInstances(accountId) {
    return axios.get(`${base(accountId)}/instances`);
  },

  linkInbox(accountId, { providerId, inboxId }) {
    return axios.post(`${base(accountId)}/link_inbox`, {
      provider_id: providerId,
      inbox_id: inboxId,
    });
  },

  getByInbox(accountId, inboxId) {
    return axios.get(`${base(accountId)}/by_inbox`, {
      params: { inbox_id: inboxId },
    });
  },

  getState(accountId, instanceId) {
    return axios.get(`${base(accountId)}/${instanceId}/state`);
  },

  getQrcode(accountId, instanceId) {
    return axios.get(`${base(accountId)}/${instanceId}/qrcode`);
  },

  getConfig(accountId, instanceId) {
    return axios.get(`${base(accountId)}/${instanceId}/get_config`);
  },

  updateConfig(accountId, instanceId, config) {
    return axios.patch(`${base(accountId)}/${instanceId}/update_config`, { config });
  },

  destroy(accountId, instanceId) {
    return axios.delete(`${base(accountId)}/${instanceId}`);
  },
};
